import React from 'react';
import styled from 'styled-components'
import { Button } from '@mintuz/marvel'

export const GhostButton = styled(Button)`
    &, &:hover, &:visited {
        color: white;
    }
`
